<template>
  <div v-if="stock_in && stock_in.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip top v-if="showView && $permission.permissionAllow('Shops', 'shopStockOrdersIn')">
        <template v-slot:activator="{ on, attrs }">
          <!-- 明细跳转 -->
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/shop-stock-orders-in/' + stock_in.id + '?shop_id=' + shop_id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("StockOrderIN.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 打印 -->
<!--      <v-tooltip-->
<!--        top-->
<!--        v-if="$permission.permissionAllow('StockInOrders', 'view')"-->
<!--      >-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <v-btn-->
<!--            v-bind="attrs"-->
<!--            v-on="on"-->
<!--            small-->
<!--            dark-->
<!--            color="print"-->
<!--            class="px-2 me-2 mb-1"-->
<!--            @click.stop="doPrint('stockOrderInPrint')"-->
<!--          >-->
<!--            <v-icon x-small class="pe-1">fa-print</v-icon>-->
<!--            {{ $t("stockInOrders.DetailFields.print") }}-->
<!--          </v-btn>-->
<!--        </template>-->
<!--        <span>{{ $t("stockInOrders.DetailFields.print") }}</span>-->
<!--      </v-tooltip>-->
      <!-- 导出 -->
      <v-tooltip
        top
        v-if="showExport && $permission.permissionAllow('Shops', 'shopStockOrdersInDetailExport')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="orderExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("StockOrderIN.DetailFields.export") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.DetailFields.export") }}</span>
      </v-tooltip>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Shops from "@/api/shops";
// import i18n from "@/i18n";

export default {
  name: "StockOrderOUTActions",

  props: {
    stock_in: Object,
    shop_id: [Number, String],
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showCancel: Boolean,
    showComplete: Boolean,
    showExport:Boolean,
    status: Number,
  },

  components: {},

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({}),

  methods: {
    orderExport(){
      Shops.shopStockOrdersInDetailExport({
        id:this.stock_in.id,
        stock_order_code: this.stock_in.stock_order_code,
        shop_id:this.shop_id
      })
    },
    // actionMethod(mode) {
    //   // if (mode == "approve") return StockIns.approve(this.stock_in.id);
    //   // else
    //   if (mode == "cancel") return StockIns.cancel(this.stock_in.id);
    // },
    // doAction(mode) {
    //   // this.$permission.checkAccountExpired().then(
    //   // function () {
    //   this.actionMethod(mode).then(
    //     function (response) {
    //       if (response.data.status.isOK()) {
    //         if (this.pageType == 1) {
    //           if (this.$route.path == "/stock-in-orders") {
    //             this.$emit("done");
    //           } else {
    //             this.$router.replace("/stock-in-orders");
    //           }
    //         }else if (this.pageType ==2) {
    //           if (this.$route.path == "/production-stock-in") {
    //             this.$emit("done");
    //           } else {
    //             this.$router.replace("/production-stock-in");
    //           }
    //         }
    //       }
    //     }.bind(this)
    //   );
    //   // }.bind(this)
    //   // );
    // },

    // StockIn() {
      // if (
      //   this.stock_in.third_return &&
      //   this.stock_in.third_return.push_platform == 1010
      // ) {
      //   this.dialog = true;
      // } else if (this.stock_in.type == 1 || this.stock_in.type == 2) {
      // Shops.checkAction(2).then(
      //   function (response) {
      //     if (response.data.status.isOK()) {
      //       if (response.data.data.actions) {
      //         if (this.pageType == 1) {
      //           this.$router.push("/stock-in-orders/" + this.stock_in.id + "/in");
      //         } else {
      //           this.$router.push("/production-stock-in/" + this.stock_in.id + "/in");
      //         }
      //       } else {
      //         this.$snackbar.error(i18n.t(response.data.data.msg));
      //       }
      //     }
      //   }.bind(this)
      // );

      // } else {
      //   this.stockOutDialog = true;
      // }
    // },
    // pushAgain() {
    //   StockIns.pushAgain(this.stock_in.id).then(
    //     function (response) {
    //       if (response.data.status.isOK()) {
    //         this.$emit("done");
    //       }
    //     }.bind(this)
    //   );
    // },
    // confirmOut() {
    //   StockIns.fetchOne(this.stock_in.id).then(
    //     function (response) {
    //       if (response.data.status.isOK()) {
    //         StockIns.stockIn(response.data.stock_in).then(
    //           function (response) {
    //             if (response.data.status.isOK()) {
    //               this.$emit("done");
    //             }
    //           }.bind(this)
    //         );
    //       }
    //     }.bind(this)
    //   );
    // },
    // doPrint(mode) {
    //   switch (mode) {
    //     case "stockOrderInPrint":
    //       this.$router.push({
    //         path: "/print/stock-order-in-print/" + this.stock_in.id,
    //         query: { type:this.stock_in.type }}
    //       );
    //       break;
    //   }
    // },
  },

  watch: {},
};
</script>